var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('pageheader',{ref:"header",class:{ 'ios-guide-header': _vm.$route.name === 'iosAppGuide' }}),_vm._v(" "),_c('router-view',{key:_vm.key}),_vm._v(" "),(
      !_vm.$route.path.includes('liveDetails') && _vm.$route.name !== 'iosAppGuide'
    )?_c('download-tip'):_vm._e(),_vm._v(" "),_c('tip-box'),_vm._v(" "),(_vm.maintainBox)?_c('main-tain',{attrs:{"maintainWords":_vm.maintainWords}}):_vm._e(),_vm._v(" "),_c('el-backtop',{attrs:{"right":42,"bottom":100}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d33e7074","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 